import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import LineChartViewer from './line'
import PairSelector from '../../components/pairSelector'
import PairResultsViewer from '../../components/pairResults'
import CustomTooltip from './components/tooltip'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { pairColor } from '../../paircolors'

class NextResult extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      displayPairResults: 4,
      remotePairResults: 4,
      displayResults: 8,
      remoteResults: 8,
      height: 300,
      pairs: null,
      selectedPairs: null,
      allPairs: true,
      fullView: false,
      combined: false,
      combinedSelectedPairs: null
    }
  }

  componentWillMount () {
    const { getSubtestResults, subtest, pager } = this.props
    getSubtestResults(pager.jid, pager.tid, subtest, 0)
    getSubtestResults(pager.jid, pager.tid, subtest, 1)
  }

  componentWillReceiveProps (nextProps) {
    const {
      getSubtestResults,
      subtest,
      pager,
      subtestResultsDisplay,
      subtestResultsRemote,
      resetResultsState
    } = nextProps
    if ( this.props.pager && subtest && this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      if (!subtestResultsDisplay[subtest]) {
        getSubtestResults(pager.jid, pager.tid, subtest, 0)
      }
      if (!subtestResultsRemote[subtest]) {
        getSubtestResults(pager.jid, pager.tid, subtest, 1)
      }
      this.setState({
        allPairs: true,
        displayPairResults: 4,
        remotePairResults: 4,
        displayResults: 8,
        remoteResults: 8,
        height: 300,
        fullView: false,
        selectedPairs: null,
        combinedSelectedPairs: null
      })
    }
    if (
      subtestResultsDisplay[subtest] &&
      subtestResultsDisplay[subtest].pairs
    ) {
      
      const combined = subtestResultsDisplay[subtest].iscombined
      let tempKey = 0
      let { selectedPairs, combinedSelectedPairs, allPairs } = this.state

      if(!selectedPairs) {
      selectedPairs = subtestResultsDisplay[subtest].pairs.map((pair, key) => {
        tempKey++
        return {
          key,
          value: pair,
          checked: true,
          stroke: pairColor(pair)
        }
      })
      }

      if (combined) {
        if(!combinedSelectedPairs) {
        combinedSelectedPairs = subtestResultsDisplay[subtest].pairs.map((pair, key) => {
          return {
            key,
            value: pair,
            checked: true,
            stroke: pairColor(pair),
            tempKey
          }
        })
      }
    }

    this.setState({
        pairs: subtestResultsDisplay[subtest].pairs,
        selectedPairs,
        combined: subtestResultsDisplay[subtest].iscombined,
        combinedSelectedPairs,
        allPairs
      })
    }
  }

  renderFullView = type => {
    let {
      displayPairResults,
      remotePairResults,
      displayResults,
      remoteResults,
      fullView,
      height
    } = this.state

    if (type === 'Main') {
      if (!fullView) {
        displayPairResults = 0
        remotePairResults = 0
        displayResults = 12
        remoteResults = 0
        height = 600
      } else {
        displayPairResults = 5
        remotePairResults = 5
        displayResults = 7
        remoteResults = 7
        height = 300
      }
    }
    if (type === 'Remote') {
      if (!fullView) {
        displayPairResults = 0
        remotePairResults = 0
        displayResults = 0
        remoteResults = 12
        height = 600
      } else {
        displayPairResults = 5
        remotePairResults = 5
        displayResults = 7
        remoteResults = 7
        height = 300
      }
    }

    this.setState({ 
      displayPairResults,
      remotePairResults,
      displayResults,
      remoteResults,
      height,
      fullView: !fullView
    })
  }

  handlePairsSelection = e => {
    let {
      selectedPairs,
      combined,
      combinedSelectedPairs,
      allPairs
    } = this.state
    let all = false
    if (e.target.value[1] === 'all') {
      selectedPairs = selectedPairs.map((pair, key) => {
        return { ...pair, ...{ checked: !allPairs } }
      })
      if (combined) {
        combinedSelectedPairs = combinedSelectedPairs.map((pair, key) => {
          return { ...pair, ...{ checked: !allPairs } }
        })
      }
      this.setState({
        allPairs: !allPairs,
        selectedPairs,
        combinedSelectedPairs
      })
    } else {
      let selected = selectedPairs.findIndex(x => x.key === e.target.value[1])
      selectedPairs[selected].checked = !selectedPairs[selected].checked
      all = selectedPairs.findIndex(x => x.checked === false) === -1
      let selectedCombined
      if (combined) {
        selectedCombined = combined
          ? combinedSelectedPairs.findIndex(x => x.key === e.target.value[1])
          : null
        combinedSelectedPairs[selected].checked = !combinedSelectedPairs[
          selected
        ].checked
      }
      this.setState({
        allPairs: all,
        selectedPairs,
        combinedSelectedPairs
      })
    }
  }

  render () {
    const {
      classes,
      translate,
      subtestResultsRemote,
      subtestResultsDisplay,
      chartLineStyle,
      chartMeasurement,
      showMargin,
      subtest
    } = this.props

    const {
      displayPairResults,
      remotePairResults,
      displayResults,
      remoteResults,
      selectedPairs,
      combinedSelectedPairs,
      allPairs,
      fullView,
      combined,
      height
    } = this.state

    if (!subtestResultsRemote[subtest] && !subtestResultsDisplay[subtest]) {
      return null
    }

    return (
      <div ref='container'>
        <Paper className={classes.paper}>
          {/* {subtestResultsDisplay[subtest] && subtestResultsRemote[subtest] && ( */}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} align='center'>
            <PairSelector
              handlePairsSelection={this.handlePairsSelection}
              selectedPairs={selectedPairs}
              combinedSelectedPairs={combinedSelectedPairs}
              allPairs={allPairs}
              combined={combined}
              translate={translate}
            />
          </Grid>
          {/* )} */}
          {subtestResultsDisplay[subtest] &&
            <Grid container spacing={24}>
              {displayPairResults !== 0 &&
                <Grid
                  item
                  xs={displayPairResults}
                  sm={displayPairResults}
                  md={displayPairResults}
                  lg={displayPairResults}
                  xl={displayPairResults}
                >
                  <PairResultsViewer
                    data={subtestResultsDisplay[subtest].pairdetails}
                    translate={translate}
                  />
                </Grid>}
              {displayResults !== 0 &&
                <Grid
                  className={classes.graph}
                  item
                  xs={displayResults}
                  sm={displayResults}
                  md={displayResults}
                  lg={displayResults}
                  xl={displayResults}
                >
                  <LineChartViewer
                    translate={translate}
                    pairs={subtestResultsDisplay[subtest].pairs}
                    data={subtestResultsDisplay[subtest].data}
                    type={translate('results_chart_display')}
                    graphType="Main"
                    renderFullView={this.renderFullView}
                    height={height}
                    selectedPairs={selectedPairs}
                    chartLineStyle={chartLineStyle}
                    chartMeasurement={chartMeasurement}
                    showMargin={showMargin}
                    fullView={fullView}
                    combined={combined}
                    combinedSelectedPairs={combinedSelectedPairs}
                    subtest={subtest}
                    CustomTooltip={<CustomTooltip />}
                  />
                </Grid>}
            </Grid>}
          {subtestResultsRemote[subtest] &&
            <Grid container spacing={24}>
              {remotePairResults !== 0 &&
                <Grid
                  item
                  xs={remotePairResults}
                  sm={remotePairResults}
                  md={remotePairResults}
                  lg={remotePairResults}
                  xl={remotePairResults}
                >
                  <PairResultsViewer
                    translate={translate}
                    data={subtestResultsRemote[subtest].pairdetails}
                  />
                </Grid>}
              {remoteResults !== 0 &&
                <Grid
                  className={classes.graph}
                  item
                  xs={remoteResults}
                  sm={remoteResults}
                  md={remoteResults}
                  lg={remoteResults}
                  xl={remoteResults}
                >
                  <LineChartViewer
                    translate={translate}
                    ks
                    pairs={subtestResultsRemote[subtest].pairs}
                    data={subtestResultsRemote[subtest].data}
                    type={translate('results_chart_remote')}
                    graphType="Remote"
                    renderFullView={this.renderFullView}
                    height={height}
                    selectedPairs={selectedPairs}
                    chartLineStyle={chartLineStyle}
                    chartMeasurement={chartMeasurement}
                    showMargin={showMargin}
                    fullView={fullView}
                    combined={combined}
                    combinedSelectedPairs={combinedSelectedPairs}
                    subtest={subtest}
                    CustomTooltip={<CustomTooltip />}
                  />
                </Grid>}
            </Grid>}

        </Paper>

      </div>
    )
  }
}

export default withStyles(styles)(NextResult)
